export class Shortcuts {
  id:string;
  sAction:string;
  sOrder:number;
}
